import {message} from "antd";
import AgencyMaintainService from "../service";

export const RUN_MONITOR_WORK_CONDITION_TABLE_LOADING = "RUN_MONITOR_WORK_CONDITION_TABLE_LOADING"; // 工况查询表格加载中
export const RUN_MONITOR_WORK_CONDITION_TABLE_INFO = "RUN_MONITOR_WORK_CONDITION_TABLE_INFO"; // 工况查询表格加载中



/**
 *  获取工况列表
 */
export const workConditionSearch = (params) => {
    return dispatch => {
        dispatch(setTableIsLoading(true))
        AgencyMaintainService.runMonitorWorkConditionService.getWorkConditionList(params).then(json => {
            if(json.code == 0){
                dispatch({
                    type: RUN_MONITOR_WORK_CONDITION_TABLE_INFO,
                    workInfo: {
                        total: json.data.total,
                        list: json.data.rows
                    }
                })
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("获取工况异常:" + e);
            message.error("获取工况失败")
        }).then(() => dispatch(setTableIsLoading(false)));
    }
}

/**
 * 工况导出
 * @param params
 */
export const exportExcel = (params) => {

}

/**
 * 设置表格是否加载中
 */
const setTableIsLoading = (isLoading) => {
    return {
        type: RUN_MONITOR_WORK_CONDITION_TABLE_LOADING,
        isLoading: isLoading
    }
}


